'use strict';

const ItemView = require('system/ui/view/diagram/item');

module.exports = ItemView.extend({
    templateContext: function() {
        return {
            draggable: true
        }
    },
    onRender: function() {
        this.$el.draggable({
            revert: true,
            revertDuration: 200,
            axis: 'y',
            zIndex: 10000
        });
        $(this.el).data('backbone-view', this);

        this.showItemLink = this.getOption('showItemLink');
        if(!this.showItemLink) {
            this.$('.list-item-header-title a')
                .click(function () {
                    return false;
                });
        }
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram/item-edit.js